import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "./Button";
import { useDispatch, useSelector } from "react-redux";
import { rxToggleNetworkErrorModal } from "../slices/appSlice";

export const AppModal = ({
                           show,
                           size = "lg",
                           className = "",
                           title,
                           children,
                           onCancel = null,
                           onSubmit = null,
                           cancelLabel = null,
                           submitLabel = null,
                           submitVariant = "primary",
                           cancelVariant = "secondary"
                         }) => {
  const [saving, setSaving] = useState(false);

  const submit = () => {
    setSaving(true);

    if (onSubmit) {
      onSubmit().finally(() => setSaving(false));
    }
  };

  return <Modal show={show} size={size} className={className}>
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{children}</Modal.Body>
    {(onCancel || onSubmit) && <Modal.Footer>
      {onCancel && <Button onClick={onCancel} variant={cancelVariant} disabled={saving}>
        {cancelLabel}
      </Button>}
      {onSubmit && <Button variant={submitVariant} disabled={saving} onClick={submit}>
        {submitLabel}
      </Button>}
    </Modal.Footer>}
  </Modal>;
};

export const NetworkErrorModal = () => {
  const dispatch = useDispatch();

  const show = useSelector(state => state.app.networkErrorModal);
  const error = useSelector(state => state.app.networkErrorModalError);

  return <AppModal
    show={show}
    title="network_error_modal_title"
    onSubmit={() => {
      dispatch(rxToggleNetworkErrorModal());

      return Promise.resolve();
    }}
    submitLabel="Close"
    submitVariant="danger"
  >
    {error && process.env.NODE_ENV === "production" && "network_error_modal_body"}
    {error && process.env.NODE_ENV !== "production" && error.message}
    {error && process.env.NODE_ENV !== "production" && <pre>{JSON.stringify(error.data, null, 2)}</pre>}
  </AppModal>;
};

export const DeleteModal = ({show, title, onCancel, onSubmit, cancelLabel, submitLabel, size, className, children}) => {
  return <AppModal
    className={className}
    size={size}
    show={show}
    title={title}
    onCancel={onCancel}
    onSubmit={onSubmit}
    cancelLabel={cancelLabel}
    submitLabel={submitLabel}
    submitVariant="danger"
  >
    {children}
  </AppModal>;
};
